export const businessCustomerActionTypes = {
    START_FETCH_CUSTOMERS: "START_FETCH_CUSTOMERS",
    FETCH_CUSTOMERS_SUCCESS: "FETCH_CUSTOMERS_SUCCESS",
    FETCH_CUSTOMERS_FAILURE: "FETCH_CUSTOMERS_FAILURE",
  };
  